@if (settings.header.enabled()) {
  <section data-cy="data-guard--header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="data-guard--header">
    @if (settings.header.svgIcon()) {
      <mat-icon [svgIcon]="settings.header.svgIcon()"></mat-icon>
    }
    @if (settings.header.title()) {
      <span fxFlex fxLayout="row" fxLayoutAlign="start center" class="data-guard--header-title fw-600">
        {{ settings.header.title() | translate }}
        @if (settings.header.infoIcon()) {
          &nbsp;
          <mat-icon [matTooltip]="settings.header.infoTooltip() | translate" matTooltipClass="regular-tooltip">info_outlined</mat-icon>
        }
      </span>
    }
    @if (settings.header.closeButton()) {
      <button mat-icon-button class="regular-round-button" (click)="closeDrawerClicked()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </section>
}
<section>
  @if (settings.content.tabs && selectedTabIndex() !== -1) {
    <mat-tab-group color="accent" [selectedIndex]="selectedTabIndex()">
      @for (tab of settings.content.tabs | keyvalue; track tab.key) {
        <mat-tab [label]="tab.key" [disabled]="$safeNavigationMigration(tab.value.disabled?.())">
          <ng-template matTabLabel>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
              <span>{{ tab.value.label() | translate | uppercase }}</span>
              @if (tab.value?.containsError?.()) {
                <div class="data-guard--error-indicator"></div>
              }
            </div>
          </ng-template>
          <ng-template matTabContent>
            @if (this[tab.key] && !tab.value.disabled?.()) {
              <ng-container *ngTemplateOutlet="this[tab.key]" />
            }
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  }
</section>

<ng-template #overview>
  <iot-platform-feature-data-guard-overview-tab
    (dispatchEvent)="onDispatchOverviewTabEvent($event)"
    [loading]="overviewChecksLoading()"
    [overviewChecks]="overviewChecks()"
  />
</ng-template>

<ng-template #detail>
  <iot-platform-feature-data-guard-detail-tab [detailedChecks]="detailedChecks()" [loading]="detailedChecksLoading()" />
</ng-template>
